// let observerInstance=null;
export default {
  name: 'virtualCom',
  data() {
    return {
      visiableDom: true,
      // 控制是否显示真实组件
      hasShow: false,
      // 控制是否已经显示过真实组件
      observerInstance: null
    };
  },
  inject: ['rootDom'],
  props: {
    index: {
      type: Number,
      default: 0
    },
    rootMargin: {
      type: String,
      default: '500px 0px 500px 0px'
    },
    height: {
      type: String,
      default: ''
    }
  },
  mounted() {
    const observer = this.getIntersectionObserver(this.onElementEnter, this.onElementLeave);
    const id = document.getElementById(`virtualDom-${this.index}`);
    observer.observe(id);
    // todo 动态获取子元素高度
  },

  methods: {
    // 创建一个单例模式的 IntersectionObserver 实例
    getIntersectionObserver(callbackEnter, callbackLeave) {
      if (!this.observerInstance) {
        this.observerInstance = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              // 元素进入视口
              callbackEnter(entry.target);
            } else {
              // 元素离开视口
              callbackLeave(entry.target);
            }
          });
        }, {
          root: this.rootDom() || null,
          rootMargin: this.rootMargin,
          threshold: 0
        });
      }
      return this.observerInstance;
    },
    // 进入视口的回调函数
    onElementEnter(element) {
      this.visiableDom = true;
      this.hasShow = true;
    },
    // 离开视口的回调函数
    onElementLeave(element) {
      if (this.hasShow) {
        this.visiableDom = false;
        this.$emit('deleteDom', element);
      }
    }
  }
};